import React, { useEffect, useState } from "react";
import HumanFigure from "../../assets/Images/HumanFigure.svg";
import BodyPartMarker from "../../assets/Images/bodyPartMarker.svg";
import styles from "./HumanOverallReport.module.scss";
import Moderate from "../../assets/Images/bodyPartMarkerModerate.svg";

const HumanOverallReport = ({ data }) => {
  console.log("HumanOverallReport", data);
  const leftShoulderDescRef = React.useRef(null);
  const leftShoulderImgRef = React.useRef(null);
  const leftNeckDescRef = React.useRef(null);
  const leftNeckImgRef = React.useRef(null);
  const leftBackDescRef = React.useRef(null);
  const leftBackImgRef = React.useRef(null);
  const leftLowerLimbDescRef = React.useRef(null);
  const leftLowerLimbImgRef = React.useRef(null);
  const leftHoldDescRef = React.useRef(null);
  const leftHoldImgRef = React.useRef(null);
  const rightShoulderDescRef = React.useRef(null);
  const rightShoulderImgRef = React.useRef(null);
  const rightBackDescRef = React.useRef(null);
  const rightBackImgRef = React.useRef(null);
  const rightLowerLimbDescRef = React.useRef(null);
  const rightLowerLimbImgRef = React.useRef(null);
  const rightHoldDescRef = React.useRef(null);
  const rightHoldImgRef = React.useRef(null);
  const rightNeckDescRef = React.useRef(null);
  const rightNeckImgRef = React.useRef(null);

  const [reportData, setReportData] = useState([]);
  const svgRef = React.useRef(null); // reference to the SVG element
  const refs = {
    "Left Neck": { desc: leftNeckDescRef, img: leftNeckImgRef },
    "Left Shoulder": { desc: leftShoulderDescRef, img: leftShoulderImgRef },
    "Left Back": { desc: leftBackDescRef, img: leftBackImgRef },
    "Left Lower Limb": { desc: leftLowerLimbDescRef, img: leftLowerLimbImgRef },
    "Left Hold": { desc: leftHoldDescRef, img: leftHoldImgRef },
    "Right Neck": { desc: rightNeckDescRef, img: rightNeckImgRef },
    "Right Shoulder": { desc: rightShoulderDescRef, img: rightShoulderImgRef },
    "Right Back": { desc: rightBackDescRef, img: rightBackImgRef },
    "Right Lower Limb": {
      desc: rightLowerLimbDescRef,
      img: rightLowerLimbImgRef,
    },
    "Right Hold": { desc: rightHoldDescRef, img: rightHoldImgRef },
    // ... add entries for each body part ...
  };
  const [lineCoords, setLineCoords] = React.useState({
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
  });

  useEffect(() => {
    if (data) {
      setReportData(data);
    }
  }, [data]);

  const [lines, setLines] = useState({});

  React.useEffect(() => {
    const mediaQueryList = window.matchMedia("print");

    const handleBeforePrint = () => {
      // Call your line update function here
      updateLines();
    };

    mediaQueryList.addListener(handleBeforePrint);

    return () => {
      mediaQueryList.removeListener(handleBeforePrint);
    };
  }, []);

  const updateLines = () => {
    const svgBoundingBox = svgRef.current.getBoundingClientRect();
    const svgActualWidth = svgBoundingBox.width;
    const svgScaleFactor = svgActualWidth / 1280;

    const newLines = {};

    for (let bodyPart in refs) {
      if (refs[bodyPart].desc.current && refs[bodyPart].img.current) {
        const descRect = refs[bodyPart].desc.current.getBoundingClientRect();
        const imgRect = refs[bodyPart].img.current.getBoundingClientRect();

        let x1;
        if (bodyPart.startsWith("Right")) {
          x1 = descRect.left - svgBoundingBox.left; // Adjust for SVG bounding box
        } else {
          x1 = descRect.right - svgBoundingBox.left;
        }

        newLines[bodyPart] = {
          x1: x1 / svgScaleFactor, // Adjust by scale factor
          y1:
            (descRect.top + descRect.height / 2 - svgBoundingBox.top) /
            svgScaleFactor,
          x2: (imgRect.left - svgBoundingBox.left) / svgScaleFactor,
          y2:
            (imgRect.top + imgRect.height / 2 - svgBoundingBox.top) /
            svgScaleFactor,
        };
      }
    }

    setLines(newLines);
  };

  React.useEffect(() => {
    // Call once to set the initial coordinates
    updateLines();

    // Add the event listener for window resize
    window.addEventListener("resize", updateLines);

    // Cleanup function to remove the event listener
    return () => window.removeEventListener("resize", updateLines);
  }, [reportData]);

  React.useEffect(() => {
    if (typeof ResizeObserver !== "undefined") {
      const resizeObserver = new ResizeObserver(() => updateLines());

      if (svgRef.current) {
        resizeObserver.observe(svgRef.current);
      }

      return () => {
        if (svgRef.current) {
          resizeObserver.unobserve(svgRef.current);
        }
      };
    }
  }, [reportData]);

  const getMarkerImage = (bodyPart) => {
    const bodyPartData = reportData.filter(
      (data) => data.body_part_name === bodyPart
    );
    const sample1 = bodyPartData.map((data) => data.exercise_interpretations);
    const sample2 = sample1.map((data) =>
      data.map((data) => data.interpretation)
    );
    const containsHigh = sample2.some((subArray) => subArray.includes("High"));
    if (containsHigh) {
      return BodyPartMarker;
    }
    return Moderate;
  };

  const getMarkerImageForNeck = (bodyPart) => {
    const bodyPartData = reportData.filter(
      (data) => data.body_part === bodyPart
    );
    const sample1 = bodyPartData.map((data) => data.exercise_interpretations);
    const sample2 = sample1.map((data) =>
      data.map((data) => data.interpretation)
    );
    const containsHigh = sample2.some((subArray) => subArray.includes("High"));
    if (containsHigh) {
      return BodyPartMarker;
    }
    return Moderate;
  }

  const bodyPartDescCard = (bodyPart) => {
    const bodyPartData = reportData.filter(
      (data) => data.body_part_name === bodyPart
    );
    return (
      <>
        <div className={styles.title}>
          {bodyPartData.length > 0 ? bodyPartData[0].body_part_name : bodyPart}
        </div>
        <div className="">
          {bodyPartData.length > 0 &&
            bodyPartData[0].exercise_interpretations.map(
              (interpretation, index) => {
                return (
                  <div key={index} className="flex justify-between">
                    <div className={styles.exeName}>
                      {interpretation.exercise_name}
                    </div>
                    <div
                      className={styles.interpretations}
                      style={{
                        color: interpretation.color_code,
                      }}
                    >
                      {interpretation.interpretation}
                    </div>
                  </div>
                );
              }
            )}
        </div>
      </>
    );
  };

  return (
    <div className={styles.humanOverallReportContainer}>
      <svg
        ref={svgRef}
        viewBox="0 0 1280 700"
        className="w-full h-auto overflow-visible max-w-[1280px]"
        style={{ margin: "0 auto" }}
      >
        <foreignObject
          width="100%"
          height="100%"
          style={{
            overflow: "visible",
          }}
        >
          <div className="flex justify-center">
            <div className="flex flex-col gap-3">
              <div className={styles.bodyPartDescCard} ref={leftNeckDescRef}>
                {bodyPartDescCard("Left Neck")}
              </div>
              <div
                className={styles.bodyPartDescCard}
                ref={leftShoulderDescRef}
              >
                {bodyPartDescCard("Left Shoulder")}
              </div>
              <div className={styles.bodyPartDescCard} ref={leftBackDescRef}>
                {bodyPartDescCard("Left Back")}
              </div>
              <div
                className={styles.bodyPartDescCard}
                ref={leftLowerLimbDescRef}
              >
                {bodyPartDescCard("Left Lower Limb")}
              </div>
              <div className={styles.bodyPartDescCard} ref={leftHoldDescRef}>
                {bodyPartDescCard("Left Hold")}
              </div>
            </div>
            <div className="flex justify-center">
              <div
                className="relative"
                style={{
                  marginLeft: "80px",
                  marginRight: "80px",
                  marginBottom: "16px",
                  marginTop: "28px",
                }}
              >
                <img
                  src={HumanFigure}
                  className="
                  max-w-none"
                  width={160}
                  height={416}
                  alt=""
                />
                <img
                  src={getMarkerImageForNeck("Neck")}
                  ref={leftNeckImgRef}
                  id="neck"
                  className="absolute top-[50px] left-[70px]"
                  alt=""
                />
                 <img
                  src={getMarkerImageForNeck("Neck")}
                  ref={rightNeckImgRef}
                  id="neck"
                  className="absolute top-[50px] left-[70px]"
                  alt=""
                />
                <img
                  src={getMarkerImage("Left Shoulder")}
                  ref={leftShoulderImgRef}
                  className="absolute left-[32px] top-[72px]"
                  alt=""
                />
                <img
                  src={getMarkerImage("Right Shoulder")}
                  className="absolute top-[72px] left-[110px]"
                  ref={rightShoulderImgRef}
                  alt=""
                />
                <img
                  src={getMarkerImage("Left Back")}
                  className="absolute left-[50px] top-[188px]"
                  ref={leftBackImgRef}
                  alt=""
                />
                <img
                  src={getMarkerImage("Right Back")}
                  className="absolute left-[94px] top-[188px]"
                  ref={rightBackImgRef}
                  alt=""
                />
                <img
                  src={getMarkerImage("Left Lower Limb")}
                  className="absolute top-[280px] left-[44px]"
                  ref={leftLowerLimbImgRef}
                  alt=""
                />
                <img
                  src={getMarkerImage("Right Lower Limb")}
                  className="absolute top-[280px] left-[102px]"
                  alt=""
                  ref={rightLowerLimbImgRef}
                />
                <img
                  src={getMarkerImage("Left Hold")}
                  className="absolute top-[376px] left-9"
                  ref={leftHoldImgRef}
                  alt=""
                />
                <img
                  src={getMarkerImage("Right Hold")}
                  className="absolute top-[376px] left-[114px]"
                  alt=""
                  ref={rightHoldImgRef}
                />
              </div>
            </div>
            <div className="flex gap-3 flex-col">
              <div className={styles.bodyPartDescCard} ref={rightNeckDescRef}>
                {bodyPartDescCard("Right Neck")}
              </div>
              <div
                className={styles.bodyPartDescCard}
                ref={rightShoulderDescRef}
              >
                {bodyPartDescCard("Right Shoulder")}
              </div>
              <div className={styles.bodyPartDescCard} ref={rightBackDescRef}>
                {bodyPartDescCard("Right Back")}
              </div>
              <div
                className={styles.bodyPartDescCard}
                ref={rightLowerLimbDescRef}
              >
                {bodyPartDescCard("Right Lower Limb")}
              </div>
              <div className={styles.bodyPartDescCard} ref={rightHoldDescRef}>
                {bodyPartDescCard("Right Hold")}
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <div className={styles.bodyPartDescCard}>
              {bodyPartDescCard("Full Body")}
            </div>
          </div>
        </foreignObject>
        {Object.values(lines).map((line, idx) => (
          <line
            key={idx}
            x1={line.x1}
            y1={line.y1}
            x2={line.x2}
            y2={line.y2}
            stroke="#FEBBA6"
            strokeWidth="1"
            strokeDasharray={2}
          />
        ))}
      </svg>
    </div>
  );
};

export default HumanOverallReport;
